import apple from '@/materiaux/assets/logos/apple.png';
import belambra from '@/materiaux/assets/logos/belambra.png';
import carrefour from '@/materiaux/assets/logos/carrefour.png';
import decathlon from '@/materiaux/assets/logos/decathlon.png';
import disneyland from '@/materiaux/assets/logos/disneyland.png';
import ikea from '@/materiaux/assets/logos/ikea.png';
import oxybul from '@/materiaux/assets/logos/oxybul.png';

export * from './images';
export * from './map';
export * from './sort';

export const NODES_DEPTH = 3;

export const PRODUCT_SLIDER = { full: 3, desktop: 2, phone: 1 };

export const ORDER_TIMELINE_STEPS = [
  'validated',
  'processing',
  'delivering',
  'delivered',
];

export const ROUTE_CART = '/cart';
export const ROUTE_CART_CHECKOUT = `${ROUTE_CART}/checkout`;
export const ROUTE_CART_CHECKOUT_CONFIRM = `${ROUTE_CART_CHECKOUT}/confirm`;
export const ROUTE_CART_CHECKOUT_STEP_1 = `${ROUTE_CART_CHECKOUT}/step1`;
export const ROUTE_CART_CHECKOUT_STEP_1_ADDRESS = `${ROUTE_CART_CHECKOUT}/step1/address`;
export const ROUTE_CART_CHECKOUT_STEP_1_MAP = `${ROUTE_CART_CHECKOUT}/step1/map`;
export const ROUTE_CART_CHECKOUT_STEP_1_WAREHOUSE = `${ROUTE_CART_CHECKOUT}/step1/warehouse`;
export const ROUTE_CART_CHECKOUT_STEP_2 = `${ROUTE_CART_CHECKOUT}/step2`;
export const ROUTE_CART_CHECKOUT_STEP_3 = `${ROUTE_CART_CHECKOUT}/step3`;
export const ROUTE_REFUND = '/refund';
export const ROUTE_REFUND_STEP1 = `${ROUTE_REFUND}/step1`;
export const ROUTE_REFUND_STEP2 = `${ROUTE_REFUND}/step2`;
export const ROUTE_REFUND_STEP3 = `${ROUTE_REFUND}/step3`;
export const ROUTE_WISHLIST = '/wishlist';

// Prices summary type
export const SUMMARY_TYPE = {
  cart: 'cart',
  checkout: 'checkout',
};

/**
 * Return static list of partners
 * @type {array}
 */
export const PARTNERS = [
  {
    name: 'apple',
    image: apple,
  },
  {
    name: 'belambra',
    image: belambra,
  },
  {
    name: 'carrefour',
    image: carrefour,
  },
  {
    name: 'decathlon',
    image: decathlon,
  },
  {
    name: 'disneyland',
    image: disneyland,
  },
  {
    name: 'ikea',
    image: ikea,
  },
  {
    name: 'oxybul',
    image: oxybul,
  },
];

export const FREE_SHIPPING_LEVEL = 10000; // 100€
